import { Mediaclip } from 'app/interfaces/mediaclip';
import { SapiEntity } from './../../../services/sapi.service';
import { Location } from '@angular/common';
import { Observable, Subject } from 'rxjs';
import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { Creative } from './../../../interfaces/adservices';
import { AbstractDetailsComponent } from '../../shared/abstract-details.component';
import { ModalDefinition } from '../../../services/overlay.service';
import { VastDetailsReactComponent } from './vast-details-react.component';

@Component({
	selector: 'vast-details',
	templateUrl: './vast-details.component.html',
	styleUrls: ['./vast-details.component.scss']
})

export class VastDetailsComponent extends AbstractDetailsComponent implements OnInit {

	@ViewChild('formRef', { static: true }) form: NgForm;
	@ViewChild(VastDetailsReactComponent) reactComponent: VastDetailsReactComponent;

	activeTab: string;
	creative: Creative;
	preview: boolean;

	constructor(protected route: ActivatedRoute,
		protected location: Location) {
		super(route, location);

		this.entityConfiguration = {
			name: 'creative',
			parentPath: '/adservices/vastservice',
			basePath: '/adservices/vastservice/creatives/'
		};
	}

	get mediaclip() {
		return this.entity as Mediaclip;
	}

	ngOnInit() {
		super.ngOnInit();
	}

	playerCreated(event: any) {

	}

	showEngagement(id: string, title: string) {
		const modal: ModalDefinition = {
			icon: 'film',
			title,
			component: {
				name: 'stats-progress',
				inputs: {
					clipId: id,
					hideViews: true
				}
			}
		};

		this.overlayService.createModal(modal);
	}

	load(id: string): Observable<SapiEntity> {

		const loadObservable = super.load(id);

		loadObservable.subscribe((entity) => {
			this.creative = this.entity as Creative;
			if (this.creative && this.creative.eventTrackers) {
				this.creative.eventTrackers = JSON.parse(this.creative.eventTrackers);
			}
			this.entity = this.creative as SapiEntity;
		});

		return loadObservable;
	}

	save(force?: boolean): Observable<any> {
		this.creative = this.entity as Creative;

		if (this.creative && this.creative.eventTrackers && typeof this.creative.eventTrackers !== 'string') {
			this.creative.eventTrackers = JSON.stringify(this.creative.eventTrackers);
		}

		this.entity = this.creative as SapiEntity;

		const quickEditSubject = this.quickeditService.save();

		quickEditSubject.subscribe(() => {
			const saveSubject = super.save(force, null, false);

			saveSubject.subscribe(() => {
				this.creative = this.entity as Creative;
				if (this.creative && this.creative.eventTrackers) {
					this.creative.eventTrackers = JSON.parse(this.creative.eventTrackers);
				}
				this.entity = this.creative as SapiEntity;
			});
			return saveSubject;
		});

		return quickEditSubject;
	}

	cancel(): Subject<SapiEntity> {
		// note: react data is stored seperately
		if (this.activeTab === 'react') {
			this.reactComponent.cancel();
		}
		return super.cancel();
	}
}
